import { render, staticRenderFns } from "./reviseReservoirArea.vue?vue&type=template&id=c6ce3772&scoped=true&"
import script from "./reviseReservoirArea.vue?vue&type=script&lang=js&"
export * from "./reviseReservoirArea.vue?vue&type=script&lang=js&"
import style0 from "./reviseReservoirArea.vue?vue&type=style&index=0&id=c6ce3772&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6ce3772",
  null
  
)

export default component.exports